import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
} from "chart.js";
import { Pie, Bar, Line } from "react-chartjs-2";
import { MoveDown, MoveUp,Calendar } from "lucide-react";
import axios from "axios";
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import DateRangePicker from "../components/DateRangePicker"; 


ChartJS.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement
);

export default function Dashboard() {

  const [user, setUser] = useState(null);
  const [options, setOptions] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [ShowModalFilterAjuan, setShowModalFilterAjuan] = useState(false);
  const [showModal, setShowModal] = useState(false);
 
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
   
 useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    setLoading(true);
    try {
      // Ganti URL API sesuai dengan endpoint kamu
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}api/events`);
      // Pastikan API mengembalikan data array seperti: [{id:1,name:"Event A"}, ...]
      const formatted = res.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setOptions(formatted);
    } catch (err) {
      console.error("Gagal memuat event:", err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const email = storedUser?.email;
      const level = storedUser?.level;
  
      fetch(`${process.env.REACT_APP_BASE_URL}api/users/search?email=${encodeURIComponent(email)}`)
          .then((res) => res.json())
          .then((data) => {
              if (data.status === "success") {
              setUser(data.data);
              console.log("Respon api search email:", data.data);
              } else {
              console.error(data.message);
              }
          })
          .catch((err) => console.error(err));
    }, []);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const BASE = process.env.REACT_APP_BASE_URL || "";

  useEffect(() => {
    let mounted = true;
    async function fetchData() {
      setLoading(true);
      try {
        const res = await fetch(`${BASE}api/dashboard`);
        if (!res.ok) throw new Error("API error");
        const json = await res.json();
        if (mounted) setData(json);
      } catch (err) {
        console.error("Gagal fetch dashboard:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    fetchData();
    return () => (mounted = false);
  }, [BASE]);

  if (loading || !data) {
    return (
      <div className="p-6">
        <p className="text-gray-500">Loading dashboard...</p>
      </div>
    );
  }

  // Chart data
  const lineData = {
    labels: data.trends.map((t) => t.month),
    datasets: [
      {
        label: "Total Ajuan",
        data: data.trends.map((t) => t.total),
        borderColor: "#4f46e5",
        backgroundColor: "#4f46e5",
      },
      {
        label: "Sudah Transfer",
        data: data.trends.map((t) => t.transfered),
        borderColor: "#10b981",
        backgroundColor: "#10b981",
      },
    ],
  };

  const barData = {
    labels: data.summary.typeDistribution.map((t) => t.type),
    datasets: [
      {
        label: "Jumlah",
        data: data.summary.typeDistribution.map((t) => t.count),
        backgroundColor: "#06b6d4",
      },
    ],
  };

  const pieData = {
    labels: data.statusDistribution.map((s) => s.name),
    datasets: [
      {
        data: data.statusDistribution.map((s) => s.value),
        backgroundColor: ["#10b981","#2649e9ff", "#f5f234ff", "#ef4444" ],
      },
    ],
  };

  const pieOptions = {
    plugins: {
      legend: {
        position: "left", 
        align: "center", 
        labels: {
          boxWidth: 15,
          padding: 20,
        },
      },
    },
  };


  const prev = data.summary.totalPrevMonth ?? 0;
  const now = data.summary.totalThisMonth ?? 0;

  const isUp = now > prev;
  const isDown = now < prev;
  const isSame = now === prev;

  const styleSelectReact = {
    control: (base) => ({
      ...base,
      borderColor: "#ced4da",
      boxShadow: "none",
      "&:hover": { borderColor: "#86b7fe" },
      borderRadius: "0.375rem",
      width: "200px"
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const handleSelectChange = (selected) => {
    if (selected && selected.value) {
      // arahkan ke halaman baru dengan parameter id
      setSuccess(`Filter berdasarkan Event`);
      setTimeout(() => setSuccess(false), 30000);
      navigate(`/dashboardFilteredEvent/${selected.value}`);
    }
  };

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <header className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold uppercase">Dashboard</h1>
        <div className="flex items-center gap-3">
          <button
            className="px-3 py-1 bg-gradient-to-br from-indigo-600 to-violet-500 text-white rounded-2xl hover:bg-indigo-700 shadow-lg hover:scale-110 transition"
            onClick={() => window.location.reload()}  
          >
            Refresh
          </button>
          <button type="button"
            onClick={() => setShowModal(true)} className="flex items-center bg-gradient-to-br from-green-500 to-emerald-950 text-white rounded-2xl hover:bg-green-400 text-white px-3 py-1  gap-2 rounded shadow text-md">
            <Calendar size={12} /> Filter Tanggal
          </button>
          <Select
              styles={styleSelectReact}
              options={options}
              value={selectedEvent}
              onChange={handleSelectChange}
              placeholder={loading ? "Memuat data..." : "Pilih Event"}
              isLoading={loading}
              isClearable
              isSearchable
          />
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <form className="space-y-4">
              <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-md w-full">
                <h3 className="text-lg font-bold mb-4">Filter Tanggal</h3>
  
                {/* Komponen DateRange */}
                <DateRangePicker
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                />
  
                <div className="flex justify-end gap-2 mt-6">
                  <button
                    onClick={() => setShowModal(false)}
                    className="bg-gradient-to-br from-gray-300 to-slate-950 text-white px-4 py-2 rounded-2xl hover:scale-110 transition"
                  >
                    Batal
                  </button>
                  <button
                    onClick={() => {
                      const start = startDate ? format(startDate, "yyyy-MM-dd") : "";
                      const end = endDate ? format(endDate, "yyyy-MM-dd") : "";
                      setShowModal(false);
                      navigate(`/dashboardFilteredDate?start=${start}&end=${end}`);
                      setShowModal(false);                    
                    }}
                    className="bg-gradient-to-br from-cyan-500 to-blue-800 text-white px-4 py-2 rounded-2xl hover:scale-110 transition"
                  >
                    Terapkan
                  </button>
                </div>
              </div>
              </form>
          </div>
        )}
        </div>
      </header>
      <section className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card
          title="Total Nominal Ajuan (Bulan ini)"
          title2="Dari total Ajuan:"
          value={
            <div className="flex">
              {formatCurrency(data.summary.totalThisMonth)}
              
            </div>
          }
          value2={data.summary.totalAjuanThisMonth}
          color='black'
        />
        <Card
          title="total nominal belum transfer"
          value={formatCurrency(data.summary.totalUntransferThisMonth) || 0}
          title2="dari ajuan:"
          value2={data.summary.counts.byTransferStatus?.untransfered || 0}
          color='blue'
        />
        <Card 
          title="total nominal sudah transfer"
          value={formatCurrency(data.summary.totalTransferThisMonth) || 0}
          title2="dari ajuan:"
          value2={data.summary.counts.byTransferStatus?.transfered || 0}
          color='green'
        />
        <Card
          title="total nominal ajuan belum print"
          title2="dari ajuan:"
          value={formatCurrency(data.summary.totalUnprintedThisMonth) || 0}
          value2={data.summary.counts.byPrintStatus?.unread || 0}
          color='red'
        />
      </section>

      {/* Charts */}
      <section className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="col-span-2 bg-white rounded-2xl shadow-2xl p-4">
          <h3 className="font-medium mb-3">Tren Pengajuan (6 bulan terakhir)</h3>
          <Line data={lineData} />
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-4">
          <h3 className="font-medium mb-3">Distribusi Tipe Ajuan</h3>
          <Bar data={barData} />
          <h3 className="font-medium mb-3 mt-6">Status Transfer</h3>
          <Pie data={pieData}  options={pieOptions}  />
        </div>

      </section>

      {/* Recent Table & Notifications */}
      {/* <section className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded shadow p-4">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-medium uppercase">Recent Ajuan</h3>
            <div className="flex gap-2">
              {user.level !== "event" && (
                <button className="text-sm px-3 py-1 border rounded">
                  Lihat Semua
                </button>
              )}
              {user.level === "event" && (
                <button className="text-sm px-3 py-1 bg-green-500 text-white rounded">
                  Buat Pengajuan
                </button>
              )}
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="text-left text-xs text-gray-500 uppercase">
                  <th className="p-2">No</th>
                  <th className="p-2">Nomor</th>
                  <th className="p-2">Pemohon</th>
                  <th className="p-2">Tipe</th>
                  <th className="p-2">Jumlah</th>
                  <th className="p-2">Print</th>
                  <th className="p-2">Transfer</th>
                  <th className="p-2">Aksi</th>
                </tr>
              </thead>
              <tbody>
                {data.recent.map((r, i) => (
                  <tr key={r.id} className="border-t">
                    <td className="p-2">{i + 1}</td>
                    <td className="p-2">{r.number}</td>
                    <td className="p-2">{r.requester}</td>
                    <td className="p-2">{r.type}</td>
                    <td className="p-2">{formatCurrency(r.amount)}</td>
                    <td className="p-2">{r.printed ? "Sudah" : "Belum"}</td>
                    <td className="p-2">{r.transferred ? "Sudah" : "Belum"}</td>
                    <td className="p-2">
                      <div className="flex gap-2">
                        <button
                          className="text-xs px-2 py-1 border rounded"
                          onClick={() => alert(`Buka detail ${r.number}`)}
                        >
                          Detail
                        </button>
                        {user.level === "finance" && (
                          <>
                            <button
                              className="text-xs px-2 py-1 bg-indigo-600 text-white rounded"
                              onClick={() =>
                                alert(`Ubah status print ${r.number}`)
                              }
                            >
                              Toggle Print
                            </button>
                            <button
                              className="text-xs px-2 py-1 bg-emerald-600 text-white rounded"
                              onClick={() =>
                                alert(`Proses transfer ${r.number}`)
                              }
                            >
                              Transfer
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <aside className="bg-white rounded shadow p-4">
          <h3 className="font-medium mb-3 uppercase">Notifikasi / Reminder</h3>
          <ul className="space-y-3">
            {data.notifications.map((n) => (
              <li key={n.id} className="p-2 border rounded">
                <div className="text-sm font-medium">{n.title}</div>
                <div className="text-xs text-gray-500 mt-1">{n.detail}</div>
              </li>
            ))}
            {data.notifications.length === 0 && (
              <li className="text-sm text-gray-500">Tidak ada notifikasi</li>
            )}
          </ul>
        </aside>
      </section> */}

      <footer className="text-xs text-gray-500">
        * Data diambil dari API: <code>{`${BASE}api/dashboard`}</code>
      </footer>
    </div>
  );
}

// Komponen Card
function Card({ title, value, title2, value2,color }) {
  return (
    <div className="bg-white shadow-xl p-4 flex flex-col justify-between rounded-2xl hover:scale-110 transition">
      <div className="text-sm text-gray-500 uppercase">{title}</div>
      <div className={`mt-2 text-2xl font-semibold text-${color}-600`}>{value}</div>
      <div className="text-sm mt-2 text-gray-500 uppercase">{title2}</div>
      <div className="mt-2 text-2xl font-semibold">{value2}</div>
    </div>
  );
}

// Format Rupiah
function formatCurrency(val) {
  if (val == null) return "-";
  const n = Number(val) || 0;
  return n.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  });
}
